import React, { useState } from 'react'
import Button from '../../../utils/components/Button/Button'
import Input from '../../../utils/components/Input/Input'
import Options from '../../../utils/components/Options/Options'
import style from "./RankAdmin.module.css"
const RanksAdminView = ({ setIdRank, formik, listRanks, isEdit, setIsEdit }) => {
  const [imgSrc, setImgSrc] = useState(null)
  return (
    <div className={style.container}>
      <div className={style.form}>
        <label className={style.file}>
          {
            imgSrc && <img src={imgSrc} />
          }
          <input type="file" accept="image" onChange={e => {


            if (e.target.files[0] && e.target.files[0].type.includes('image')) {
              setImgSrc(URL.createObjectURL(e.target.files[0]))
              formik.setFieldValue("image", e.target.files[0])
            }
          }} />

        </label>
        <Input placeholder='Nombre' name="name" value={formik.values.name} onChange={formik.handleChange} />
        <Input placeholder='Descripción' name="description" value={formik.values.description} onChange={formik.handleChange} />
        <Input placeholder='Puntuación requerida' type='number' min={0} name="requiredScore" value={formik.values.requiredScore} onChange={formik.handleChange} />
        <Button type='submit' onClick={formik.handleSubmit} text={isEdit ? "Editar" : "Guardar"} />
      </div>
      <div className={style.grid}>
        {listRanks.map(rank => (
          <div className={style.card}>
            <Options options={[
              {
                onClick: (e) => {
                  setIdRank(rank._id)
                  if (rank?.image?.url?.origin) {
                    setImgSrc(rank.image.url.origin)
                    formik.setFieldValue("image", rank.image.url.origin)
                  } else {
                    setImgSrc(null)
                    formik.setFieldValue("image", null)
                  }

                  formik.setFieldValue("name", rank.name)

                  formik.setFieldValue("description", rank.description)
                  formik.setFieldValue("requiredScore", rank.requiredScore)
                  setIsEdit(true)
                },
                text: "Editar"
              }
            ]} />
            {rank?.image?.url?.origin && <img src={rank.image && rank.image.url && rank.image.url.origin} />}
            <div className='row centerItems'>
              <div className={style.title}>{rank.name}</div>
              <div>{rank.description}</div>
              <div>{rank.requiredScore}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
export default RanksAdminView

